import { prefixerT } from './common'

export const ROUTE_CREAR_ACTIVO_FIJO = prefixerT('crear')

export const ROUTE_ACTIVACION_ACTIVO_FIJO = prefixerT('activar')

export const ROUTE_REGISTRO_AVALUOS = prefixerT('registro-avaluos')

export const ROUTE_GESTION_AVALUOS = prefixerT('gestion-avaluos')

export const ROUTE_LIQUIDACION_ACTIVO_FIJO = prefixerT('liquidacion')

export const ROUTE_GESTION_ACTIVOS_FIJOS = prefixerT('gestion')

export const ROUTE_SOLICITAR_TRANSFERENCIA = prefixerT('solicitar-transferencia')

export const ROUTE_GESTION_SOLICITUDES_TRANSFERENCIA = prefixerT('gestion-solicitudes-transferencia')

export const ROUTE_APROBAR_TRANSFERENCIA = prefixerT('aprobar-transferencia')
